module.exports = __webpack_public_path__ + "img/TBWTTNL_choice_loading.0a4be30a.jpg";